import Gerstner from '../fonts/RGerstner-Regular.ttf'
import RGerstnerBold from '../fonts/RGerstner-Bold.ttf'

const GerstnerLight = {
  fontFamily: 'RGerstner',
  src: `local('R Gerstner'),url(${Gerstner}) format('woff2')`,
}

const GerstnerBold = {
  fontFamily: 'RGerstnerBold',
  src: `local('R Gerstner'),url(${RGerstnerBold}) format('woff2')`,
}

export const R_THEME = {
  palette: {
    primary: { main: '#444', light: '#f2f2f2', black: '#000000' },
    secondary: {
      contrastText: '#fff',
      main: '#444',
    },
    disabled: {
      alternativeDisableColor: '#ef3340',
      text: '#BBBDBD',
      background: '#E1E3E3',
    },
    secondaryTitle: {
      main: '#c3c3c3',
    },
    icon: {
      main: '#ff4444',
      hover: '#e6e8e8',
    },
    menu: { main: '#444444' },
    header: {
      background: '#444444',
      text: '#fff',
    },
    headerLinks: {
      background: '#444444',
      text: '#ffffff',
      hover: '#000000',
    },
    footer: {
      main: '#bfbfbf',
      background: '#333333',
      icons: '#bfbfbf',
      hover: '#ef3340',
    },
    button: {
      color: '#fff',
      backgroundColor: '#444',
      hoverColor: '#444',
      hoverBackgroundColor: '#fff',
      hoverBorderColor: '#444',
    },
    table: {
      headerText: '#9b9b9b',
    },
    success: { main: '#00D41F' },
    warning: { main: '#EEC303' },
    error: { main: '#FF0000' },
    info: { main: '#008DFF' },
    breadcrumb: {
      color: '#444444',
      backgroundColor: '#FFF',
    },
    user: {
      icon: '#444444',
      background: '#ffffff',
    },
    langBar: {
      backgroundColor: '#7f7f7f',
      color: 'black',
    },
    switchColor: {
      color300: '#444444',
      color500: '#ff935b',
    },
  },
  typography: {
    h1: {
      fontFamily: 'RGerstnerBold',
      fontSize: '1.75rem',
    },
    h2: {
      fontFamily: 'RGerstnerBold',
      fontSize: '1.5rem',
    },
    h3: {
      fontFamily: 'RGerstnerBold',
      fontSize: '1.2rem',
    },
    h4: {
      fontFamily: 'RGerstnerBold',
      fontSize: '1.2rem',
    },
    h5: {
      fontFamily: 'RGerstnerBold',
      fontSize: '1.1rem',
    },
    h6: {
      fontFamily: 'RGerstnerBold',
      fontSize: '1rem',
    },
    body1: {
      fontFamily: 'RGerstner',
      fontSize: '1rem',
    },
    body2: {
      fontFamily: 'RGerstner',
      fontSize: '0.9rem',
    },
    subtitle1: {
      fontFamily: 'RGerstner',
      fontSize: '0.7rem',
    },
    subtitle2: {
      fontFamily: 'RGerstner',
      fontSize: '0.65rem',
      fontWeight: 600,
    },
  },
  borderBottom: {
    borderBottom: '4px solid #444444',
  },
  borderTopMainMenu: {
    borderTop: '0px solid #444444',
  },
  footerShadow: {
    boxShadow: 'none',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [GerstnerLight, GerstnerBold],
        body: {
          minWidth: '289px',
          width: '100%',
          fontSize: '0.875rem',
          lineHeight: '1.43rem',
          backgroundColor: 'white',
        },
        main: {
          width: '100%',
        },
        ' .grecaptcha-badge': {
          display: 'none',
        },
        '.MuiAppBar-root': {
          display: 'block',
        },
        '.MuiPaper-rounded': {
          borderRadius: '10px !important',
        },
        '.MuiPickersDay-day.MuiPickersDay-daySelected > .MuiIconButton-label > .MuiTypography-root': {
          color: '#fff !important',
        },
        '.MuiChip-label.MuiChip-labelSmall': {
          fontFamily: 'RGerstner',
        },
        '.MuiTouchRipple-root': {
          fontFamily: 'RGerstner',
        },
        '.MuiButton-root': {
          fontFamily: 'RGerstner',
          height: '38px',
          backgroundColor: '#444',
          margin: '5px 5px 5px 0px',
          '&:hover': {
            color: '#444 !important',
          },
          '&:disabled': {
            backgroundColor: 'rgba(0,0,0,0.12)',
          },
        },
        '.MuiButton-label': {
          fontFamily: 'RGerstner',
        },
        '.MuiIconButton-root': {
          color: '#ff4444 !important',
          fontFamily: 'RGerstner',
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        '.MuiButton-textSizeSmall': {
          height: '22px',
          fontFamily: 'RGerstner',
        },
        '.MuiCardHeader-content > p': {
          marginTop: '5px',
        },
        '.MuiCardHeader-avatar': {
          marginRight: '3px !important',
        },
        '.MuiDataGrid-root': {
          border: 'none !important',
        },
        '.MuiCardContent-root:last-child': {
          padding: '16px !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-row.Mui-selected:hover': {
          'background-color': 'rgba(73, 73, 73, 0.12) !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-row.Mui-selected': {
          'background-color': 'rgba(99, 99, 99, 0.08) !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnSeparator': {
          display: 'none !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
          'background-color': 'trasparent !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
          'padding-left': '0rem !important',
          'padding-right': '0rem !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnHeaderCheckbox': {
          'padding-right': '0rem !important',
        },
        '.MuiPaper-elevation1': {
          'box-shadow': '0px 0px 13px 3px rgb(0 0 0 / 10%) !important',
        },
        '.buttons': {
          'margin-top': '0px !important',
          'flex-direction': 'row !important',
          'justify-content': 'flex-start !important',
          'font-family': 'RGerstner',
        },
        '.textErrorsColors': {
          color: 'red',
        },
        '.MuiContainer-root': {
          marginLeft: '25px',
          marginTop: '25px',
          marginBottom: '6.5rem',
        },
        '.MuiDataGrid-footerContainer': {
          position: 'relative',
          top: '10px',
        },
        '.messagesErrorInvoiceContainer': {
          paddingTop: '5px',
        },
        '.MuiMenu-paper': {
          zIndex: 9999,
        },
        '.MuiDialogContent-root': {
          overflowY: 'visible !important',
          margin: '1rem',
        },
        '*::-webkit-scrollbar': {
          width: 5,
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#444',
        },
      },
    },
  },
}
